import { faMemoCircleInfo } from '@fortawesome/pro-solid-svg-icons/faMemoCircleInfo';
import { faPuzzlePiece } from '@fortawesome/pro-solid-svg-icons/faPuzzlePiece';
import { faReceipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { faSliders } from '@fortawesome/pro-solid-svg-icons/faSliders';
import { ColourStateSolid } from '@ukpostbox/frontend-framework';
import AppIntegrations from '../Pages/Plan/AppIntegrations';
import Preferences from '../Pages/Plan/Preferences';
import PlanDetails from '../Pages/Plan/PlanDetails';
import Statements from '../Pages/Plan/Statements';
import { SuggestibleRouteInterface } from '../../_Global/Types/RouteTypes';

const YourPlanRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Preferences',
		path: '/manage-account/plan/preferences',
		icon: faSliders,
		element: <Preferences />,
		colour: ColourStateSolid.Success,
		group: 'Your Plan',
	},
	{
		title: 'Plan Details',
		path: '/manage-account/plan/details',
		icon: faMemoCircleInfo,
		element: <PlanDetails />,
		colour: ColourStateSolid.Success,
		group: 'Your Plan',
	},
	{
		title: 'Statements',
		icon: faReceipt,
		path: '/manage-account/plan/statements',
		element: <Statements />,
		colour: ColourStateSolid.Success,
		group: 'Your Plan',
	},
	{
		title: 'App Integrations',
		path: '/manage-account/app-integrations',
		icon: faPuzzlePiece,
		element: <AppIntegrations />,
		colour: ColourStateSolid.Success,
		group: 'Your Plan',
	},
];

export { YourPlanRoutes };
